import { DownloadOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { isEmpty } from "lodash";
import { isDownloadDisabled } from "modules/utilities/utility";
import moment from "moment";
import React from "react";

const CsvDownload = ({ data, extraData, type }) => {
	const getODATypes = oda => {
		let temp = oda.split(",");
		let result = [];
		temp.map(ele => {
			result.push(ODATypesMapper[ele]);
		});
		result = result.join(",");
		return result;
	};
	const exportCSV = () => {
		try {
			let csvRow = [];
			let rowName = [
				[
					encodeURIComponent("Order Id"),
					encodeURIComponent("Order Date"),
					encodeURIComponent("City"),
					encodeURIComponent("State"),
					encodeURIComponent("Pincode"),
					encodeURIComponent("Allocation Status"),
					encodeURIComponent("Allocation Reason"),
					encodeURIComponent("Phone Number"),
					encodeURIComponent("Order Amount"),
					encodeURIComponent("Order Type"),
					encodeURIComponent("Mark Shipped"),
					encodeURIComponent("Shipping Partner"),
					encodeURIComponent("ODA Type"),
				],
			];

			if (type === "b2b") {
				for (let item = 0; item < data.length; item++) {
					rowName.push([
						encodeURIComponent(data[item].order_display_id),
						encodeURIComponent(
							moment(data[item].created_at).format("DD/MM/YYYY")
						),
						encodeURIComponent(data[item].order_meta?.shipping_address?.city),
						encodeURIComponent(
							data[item].order_meta?.shipping_address?.province
						),
						encodeURIComponent(data[item].order_meta?.shipping_address?.zip),
						encodeURIComponent(data[item].allocation_status),
						encodeURIComponent(
							data[item].allocation_status_reason?.replace(/,/g, "")
						),
						encodeURIComponent(data[item].phone_number),
						encodeURIComponent(data[item].order_meta?.total_price),
						encodeURIComponent(
							data[item].order_type === "pre_paid" ? "PREPAID" : "COD"
						),
						encodeURIComponent(
							extraData && extraData[data[item].orderId]
								? extraData[data[item].orderId]?.processed
								: ""
						),
						encodeURIComponent(
							extraData && extraData[data[item].orderId]
								? extraData[data[item].orderId]?.shippingPartner
								: ""
						),
						encodeURIComponent(
							data[item].oad_type ? getODATypes(data[item].oad_type) : ""
						),
					]);
				}
			} else {
				for (let item = 0; item < data.length; item++) {
					rowName.push([
						encodeURIComponent(data[item].order_display_id),
						encodeURIComponent(
							moment(data[item].createdAt).format("DD/MM/YYYY")
						),
						encodeURIComponent(data[item].order_meta?.shipping_address?.city),
						encodeURIComponent(
							data[item].order_meta?.shipping_address?.province
						),
						encodeURIComponent(data[item].order_meta?.shipping_address?.zip),
						encodeURIComponent(data[item].allocation_status),
						encodeURIComponent(
							data[item].allocation_status_reason?.replace(/,/g, "")
						),
						encodeURIComponent(data[item].phone_number),
						encodeURIComponent(data[item].order_meta?.total_price),
						encodeURIComponent(
							data[item].order_type === "pre_paid" ? "PREPAID" : "COD"
						),
						encodeURIComponent(
							extraData && extraData[data[item].orderId]
								? extraData[data[item].orderId]?.markshipped
								: ""
						),
						encodeURIComponent(
							extraData && extraData[data[item].orderId]
								? extraData[data[item].orderId]?.shippingPartner
								: ""
						),
						encodeURIComponent(
							data[item].oad_type ? getODATypes(data[item].oad_type) : ""
						),
					]);
				}
			}

			for (let newitem = 0; newitem < rowName.length; newitem++) {
				csvRow.push(rowName[newitem].join(","));
			}

			let csvString = csvRow.join("%0A");
			let anchorTag = document.createElement("a");
			anchorTag.href = "data:attachment/csv," + csvString;
			anchorTag.target = "_Blank";
			anchorTag.download = `${type}-orders.csv`;
			document.body.appendChild(anchorTag);
			anchorTag.click();
		} catch (error) {
			message.error("download error");
		}
	};

	return (
		<Button
			type="primary"
			icon={<DownloadOutlined />}
			onClick={exportCSV}
			disabled={ isDownloadDisabled || isEmpty(data)}>
			Download Orders
		</Button>
	);
};

export default CsvDownload;

const ODATypesMapper = {
	nonServicable: "Non serviceable pin codes",
	oadOrders: "ODA",
	greaterThan5000: "Orders above 5000rs",
	blockedCustomer: "Blocked customers",
	duplicateCustomer: "Duplicate Customers",
};
